import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useTransferGroupOwner, useSetGroupAdmin } from "@/components/chat/GroupOperation";
import { SessionSettingsType, TransferGroupAdminSource } from "@/types/chat/enum";
import React, { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import IconFont from "@/components/icon";
import ScrollView from "@/baseComponents/ScrollView";
import noticeImg from "@/assets/img/empty/im-empty.png";
import { Drawer, message, Switch, Empty } from "antd";
import isNull from "lodash/isNull";
import { Employee, GroupAttribute, Session, SessionProps } from "@/types/chat";
import { sessionSetting } from "@/server/im/SessionService";
import GroupRobotOperate from "@/components/chat/SessionSetting/GroupBotsManager/robotOperate";
import Context from "@/components/chat/context";
import { groupGetBotList } from "@/api/egroup";
// sxl 连续点击switch 节流
import { debounce, throttle } from "lodash";
import bus from "@/utils/bus";
import { connect } from "dvajs";
import ChatState, { ChatConnectState } from "@/types/chat/State";
import { useHistory } from "react-router-dom";
import "./index.less";
interface Props {
  selectedSession: Session;
  sessionMembers: Partial<Employee>[];
  groupRobots: Partial<any>[];
  loadSessionMembers: Function;
  openAddRobotModal: Function;
}

type IProps = Readonly<Props>;

function GroupBotsManager (
  props: IProps & {
    visible: boolean;
    onClose: () => void;
    updateSessionData: Function;
    updateSelectedSession: Function;
  }
) {
  const {
    visible,
    onClose,
    selectedSession,
    groupRobots,
    loadSessionMembers,
    updateSessionData,
    updateSelectedSession,
    openAddRobotModal
  } = props;

  const {
    currentEmployee,
    groupRosters,
    userData,
    groupRosterIdentity,
    aiMergeOptions
  } = React.useContext(Context);
  const { t } = useTranslation("chat");

  const [robotList, setRobotList] = useState([]);

  const history = useHistory();

  const getRobotsList = useCallback(() => {
    groupGetBotList({ groupId: selectedSession.gid || "" }).then((res: any) => {
      console.log("res:", res);
      if (res.items) {
        setRobotList(res.items);
      }
    });
  }, [selectedSession]);

  // useEffect(() => {
  //   if (visible) {
  //     getRobotsList();
  //   }
  //   console.log("机器人列表～～～：", selectedSession);
  //   bus.on(`chat:session-update:${selectedSession?.sessionId}`, () => {
  //     console.log("邀请后更新机器人列表～～～：", selectedSession);
  //     getRobotsList();
  //   });
  //   return () => {
  //     bus.off(`chat:session-update:${selectedSession?.sessionId}`);
  //   };
  // }, [getRobotsList, selectedSession, visible]);

  // useEffect(()=>{},[groupRobots]);

  const addRobot = () => {
    console.log("selectedSession:", selectedSession);
    openAddRobotModal({
      visible: true,
      addRobotModalGroupId: selectedSession.sessionId || selectedSession.gid || ""
    });
  };
  const titleNode = useMemo(() => {
    return (
      <div>
        <IconFont
          type="iconwin_left"
          className="group-management-icon-arrow app-region-none"
          onClick={onClose}
        />
        <span className="management-title">{t("group_robot")}</span>
      </div>
    );
  }, [onClose, t]);

  const getItemClasses = useCallback((item: any) => {
    return classNames({
      independent: true,
      pad: !item.info
    });
  }, []);

  return (
    <Drawer
      className="group-manager-right-drawer"
      getContainer={document.querySelector("#chat-right-container-change-set") as HTMLElement}
      title={titleNode}
      placement="right"
      width="340px"
      height="100%"
      mask={false}
      destroyOnClose={true}
      closable={false}
      onClose={onClose}
      visible={visible}
      footer={
        <div className="add-robot">
          <button
            onClick={addRobot}
            // clstag="pageclick|keycount|Xtbg_Msg_Setting|DisbandGroup"
          >
            {t("add_robot")}
          </button>
        </div>
      }
      style={{ position: "absolute", right: 0 }}
    >
      {groupRobots.length > 0 && (
        <ScrollView className="members_con scroll-view" nohorizontal="true">
          {groupRobots?.map((item: any, index: any) => {
            return (
              <div className={getItemClasses(item)} key={index}>
                {/* {item?.info && ( */}
                {item?.botId && (
                  <GroupRobotOperate
                    member={{
                      gid: selectedSession.gid,
                      ...item
                    }}
                    getAllGroupMembers={() => {}}
                    keyword="test"
                    // canAddMember={true}
                  />
                )}
              </div>
            );
          })}
        </ScrollView>
      )}
      {groupRobots.length === 0 && (
        <Empty
          className="botlist-nodata"
          image={noticeImg}
          imageStyle={{
            height: 100
          }}
          description="暂无数据"
        />
      )}
    </Drawer>
  );
}

function mapStateToProps ({ chat }: { chat: ChatState }) {
  return {
    groupRosters: chat.groupRosters,
    groupRobots: chat.groupRobots,
    selectedSession: chat.selectedSession
  };
}

function mapDispatchToProps (dispatch: any) {
  return {
    async loadSessionMembers (data: { selectedSession: SessionProps }) {
      await dispatch({ type: "chat/loadSessionMembers", payload: data });
    },
    updateSessionData (data: { session: Session }) {
      dispatch({ type: "chat/updateSessionData", payload: data });
    },
    updateSelectedSession (data: { selectedSession: Session }) {
      dispatch({ type: "chat/updateSelectedSession", payload: data });
    },
    openAddRobotModal (data: any) {
      dispatch({ type: "ebook/openAddRobotModal", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupBotsManager);
